import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => {
  return {
    tooltip: {
      background: theme.palette.labraText.tertiary,
      color: theme.palette.text.white,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      minHeight: theme.spacing(3),
      borderRadius: theme.spacing(0.4),
      fontSize: '12px',
    },
    tooltipPadding: {
      padding: theme.spacing(0.4, 1),
    },
    percentage: {
      borderRadius: theme.spacing(0.4),
      padding: theme.spacing(0.25),
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
      color: theme.palette.labraText.primary,
      fontWeight: 600,
    },
    imgIcon: {
      height: theme.spacing(2.5),
      width: theme.spacing(2.5),
      background: theme.palette.text.white,
      borderRadius: theme.spacing(0.4),
      padding: theme.spacing(0.25),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    tooltipWithList: {
      background: theme.palette.labraText.tertiary,
      color: theme.palette.text.white,
      padding: theme.spacing(1),
      display: 'flex',
      gap: theme.spacing(1),
      flexDirection: 'column',
      fontSize: '12px',
      width: 'fit-content',
      borderRadius: theme.spacing(0.4),
    },
    tooltipProduct: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      gap: theme.spacing(1),
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
    productNameValue: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      gap: theme.spacing(1),
    },
    divider: {
      background: theme.palette.graphdivider.main,
    },
  }
})
